<template>
  <div class="news-cell" v-on:click="onClick(item.url)">
    <div class="news-cell-head">
      <div class="news-cell-title">{{ item.title }}</div>
      <img class="news-cell-image" :src="item.img" />
    </div>
    <div class="news-cell-foot">
      <div class="news-cell-foot-left">
        <van-tag class="tag" color="#C4C4C4" plain round v-show="item.badge">{{
          item.badge
        }}</van-tag>
        <van-icon color="#C4C4C4" class="icon" size="3.2vw" name="clock-o" />
        <span class="text">{{ dateDiff }}</span>
        <van-icon color="#C4C4C4" class="icon" size="3.2vw" name="eye-o" />
        <!-- <span class="text"> {{ item.hits }}</span> -->
      </div>
      <div class="news-cell-foot-right" v-show="item.audio">
        <!-- <van-icon class="icon" :name="require('@/assets/img/audio.png')" />
        <span class="text">播报</span> -->
      </div>
    </div>
  </div>
  <van-divider class="news-cell-divide" />
</template>

<script>
import { Tag, Divider, Icon } from "vant";
import { ref } from "vue";
import useDateDiff from "@/composiables/useDateDiff.js";
export default {
  name: "TopicCell",
  components: {
    [Tag.name]: Tag,
    [Divider.name]: Divider,
    [Icon.name]: Icon,
  },
  props: {
    item: Object,
  },
  setup(props) {
    const dateDiff = ref(useDateDiff(props.item.publishTime));
    const onClick = (url) => {
      window.open(url, "_blank");
    };
    return {
      dateDiff,
      onClick,
    };
  },
};
</script>

<style lang="scss" scoped>
.news-cell {
  padding: 20px;
}
.news-cell-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.news-cell-title {
  text-align: left;
  margin-right: 10px;
  font-size: 4.53vw;
}
.news-cell-image {
  margin-top: 10px;
  width: 100%;
  border-radius: 4px;
}

.news-cell-foot {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.news-cell-foot-left {
  display: flex;
  align-items: center;
  .tag {
    padding: 1px 4px 0 4px;
    margin-right: 18px;
    font-size: 3.2vw;
  }

  .text {
    margin-left: 4px;
    margin-right: 18px;
    font-size: 0.8em;
    color: #c4c4c4;
    font-size: 3.2vw;
  }
}
.news-cell-foot-right {
  display: flex;
  align-items: center;
  .icon {
    width: var(--van-tag-line-height);
    height: var(--van-tag-line-height);
    margin-right: 5px;
  }
  .text {
    color: rgb(252, 36, 42);
    font-size: 3.2vw;
  }
}
.news-cell-divide {
  --van-divider-margin: 0;
}
</style>
